// This should match the UNLIMITED_LIMIT from the backend
export const UNLIMITED_LIMIT = -1

export function isUnlimited(limit: number | null | undefined): boolean {
    return limit === UNLIMITED_LIMIT
}
